import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import * as fromFeedback from './feedback';
import * as fromCompanyStore from './company-stores';

export interface CompanyPageState {
  feedback: fromFeedback.FeedbackState;
  companyStore: fromCompanyStore.CompanyStoresState;
}

export const reducers: ActionReducerMap<CompanyPageState> = {
  feedback: fromFeedback.reducer,
  companyStore: fromCompanyStore.reducer,
};

export const effects = [fromFeedback.FeedbackEffects, fromCompanyStore.CompanyStoreEffects];

export const selectCompanyPageState = createFeatureSelector<CompanyPageState>('companyPage');
